import React from "react";
import Utils from "utils";

const RedirectToErrorPage = () => {
  React.useEffect(() => {
    const companyId = Utils.getCompanyId();
    const projectId = Utils.getProjectId();
    
    // companyId가 있으면 /{companyId}/error로 이동
    // projectId도 있으면 /{companyId}/{projectId}/error로 이동
    if (companyId && projectId) {
      window.location.href = `/${companyId}/${projectId}/error`;
    } else if (companyId) {
      window.location.href = `/${companyId}/error`;
    } else {
      window.location.href = `/error`;
    }
  }, []);

  // You can render a fallback UI here or return null if you don't want to render anything
  return null;
};

export default RedirectToErrorPage;
